/**
 *
 *  Footer
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 17/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback, useRef, useState } from "react";
// import PropTypes from "prop-types";
import preval from "preval.macro";
import { Link, useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { useAppState } from "../../state";
import { useRegion } from "../../context/RegionProvider";

// Components
import Button from "../Button/Button";

// Images
import AppleAppStore from "../Homepage/AppleAppStore";
import Insta from "./Insta";
import Facebook from "./Facebook";
import YouTube from "./YouTube";
import TruBeLogo from "./TruBeLogo";

const Footer = ({ regionSelect = true }) => {
  const location = useLocation();
  const { region, openModal } = useRegion();

  const { user } = useAppState();

  const isLoggedIn = !!user;
  const [email, setEmail] = useState("");
  const [hasEmailError, setHasEmailError] = useState(false);

  const emailRef = useRef();

  const handleEmailChange = useCallback((event) => {
    const value = event.target.value;

    setEmail(value);
    setHasEmailError(false);
  }, []);

  return (
    <div className="tbk-relative tbk-min-h-[376px] tbk-w-full tbk-overflow-hidden tbk-bg-grey-light tbk-py-7">
      <div className="tbk-container tbk-mx-auto tbk-px-2">
        <div className="lg:tbk-justify-center_ tbk-relative tbk-flex tbk-flex-col tbk-gap-x-4 lg:tbk-grid lg:tbk-grid-cols-footer lg:tbk-flex-row lg:tbk-items-start lg:tbk-gap-y-7 lg:tbk-gap-x-30">
          <div className="tbk--order-2 tbk-col-span-2 tbk-mb-7 tbk-flex tbk-flex-col tbk-items-center lg:tbk-order-none lg:tbk-col-auto lg:tbk-mb-0 lg:tbk-block">
            <a
              className="tb-logo-link tbk-hidden tbk-text-grey-main lg:tbk-block"
              href="/?logo=1"
            >
              <TruBeLogo className="tbk-mb-3" width={127} height={38} />
            </a>
            <a
              href="https://apps.apple.com/us/app/trube/id6449003944"
              className="tbk-mb-3 tbk-inline-block"
            >
              <AppleAppStore
                className="tbk-hidden lg:tbk-block"
                width={128}
                height={37}
              />
              <AppleAppStore className="lg:tbk-hidden" />
            </a>
            <div className="tbk-flex tbk-justify-between lg:tbk-mb-3">
              <a
                href="https://instagram.com/trubeapp"
                className="tbk-grow tbk-text-grey-main hover:tbk-text-coral"
              >
                <Insta className="tbk-mr-2" />
              </a>
              <a
                href="https://facebook.com/trubeapp"
                className="tbk-grow tbk-text-center tbk-text-grey-main hover:tbk-text-coral"
              >
                <Facebook className="tbk-mr-2 tbk-inline-block" />
              </a>
              <a
                href="https://www.youtube.com/channel/UC07WjPV6YY_1GR1XJVwOgbg"
                className="tbk-grow tbk-text-right tbk-text-grey-main hover:tbk-text-coral"
              >
                <YouTube className="tbk-inline-block" />
              </a>
            </div>
            <div className="tbk-text-small tbk-hidden tbk-text-grey-main lg:tbk-block">
              © 2025 TruBe.
              <br />
              All rights reserved.
              <br />
              <span
                className={
                  process.env.NODE_ENV === "production" ? "tbk-hidden" : ""
                }
              >
                vers. {preval`module.exports = new Date().toLocaleString();`}.
              </span>
            </div>
          </div>
          <div className="tbk-grid tbk-grid-cols-footer-links tbk-gap-x-4 tbk-gap-y-7 lg:tbk-gap-6">
            <div className="">
              <div className="tbk-text-cta tbk-mb-2 tbk-hidden tbk-uppercase tbk-text-grey-inactive">
                Company
              </div>
              {isLoggedIn ? (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to="/partners"
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    Find Your{" "}
                    <FormattedMessage id="Trainer" defaultMessage="Trainer" />
                  </Link>
                </div>
              ) : null}

              {/*{isLoggedIn ? (*/}
              {/*  <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">*/}
              {/*    <Link*/}
              {/*      to="/become-a-coach"*/}
              {/*      className="tbk-whitespace-nowrap tbk-text-grey-main"*/}
              {/*    >*/}
              {/*      Become a Coach*/}
              {/*    </Link>*/}
              {/*  </div>*/}
              {/*) : null}*/}

              <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                <Link
                  to="/about"
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                >
                  About TruBe
                </Link>
              </div>

              {!isLoggedIn ? (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to="/become-a-member"
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    Be a Member
                  </Link>
                </div>
              ) : null}

              <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                <Link
                  to="/become-a-partner"
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                >
                  Be a{" "}
                  <FormattedMessage id="Trainer" defaultMessage="Trainer" />
                </Link>
              </div>

              {/*<div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">*/}
              {/*  <Link*/}
              {/*    to="/pillars"*/}
              {/*    className="tbk-whitespace-nowrap tbk-text-grey-main"*/}
              {/*  >*/}
              {/*    Our Pillars*/}
              {/*  </Link>*/}
              {/*</div>*/}

              <div className="tbk-text-main tbk-text-grey-main">
                <a
                  href="https://blog.us.trubeapp.com"
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                  target="_blank"
                >
                  Blog
                </a>
              </div>
            </div>
            <div className="">
              <div className="tbk-text-cta tbk-mb-2 tbk-hidden tbk-uppercase tbk-text-grey-inactive">
                Support
              </div>
              {isLoggedIn ? (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to="/contact"
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    Contact Us
                  </Link>
                </div>
              ) : null}
              <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                <Link
                  to="/faq"
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                  //target="_blank"
                >
                  FAQ
                </Link>
              </div>
              <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                <a
                  href={
                    region === "GB"
                      ? "/privacy"
                      : `/terms/TruBe - US Privacy Policy.pdf`
                  }
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </div>
              <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                <a
                  href={
                    region === "GB"
                      ? "/terms/Terms of Use and Booking.pdf"
                      : `/terms/Terms of Use US.pdf`
                  }
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                  target="_blank"
                >
                  Terms of Use
                </a>
              </div>
              <div className="tbk-text-main tbk-text-grey-main">
                <a
                  href="/trust-and-safety"
                  className="tbk-whitespace-nowrap tbk-text-grey-main"
                >
                  Trust & Safety
                </a>
              </div>
            </div>
            <div className="">
              <div className="tbk-text-cta tbk-mb-2 tbk-hidden tbk-uppercase tbk-text-grey-inactive">
                Product
              </div>
              {/*{!isLoggedIn && (*/}
              {/*  <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">*/}
              {/*    <Link*/}
              {/*      to="/become-a-member"*/}
              {/*      className="tbk-whitespace-nowrap tbk-text-grey-main"*/}
              {/*    >*/}
              {/*      Become a Member*/}
              {/*    </Link>*/}
              {/*  </div>*/}
              {/*)}*/}
              {!isLoggedIn && (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to={{
                      pathname: "/login/",
                      // search: "?authState=signUp",
                      state: { from: `${location.pathname}${location.search}` },
                    }}
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    Login
                  </Link>
                </div>
              )}
              {!isLoggedIn && (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to="/contact"
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    Contact Us
                  </Link>
                </div>
              )}
              {isLoggedIn && (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to="/account"
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    My Profile
                  </Link>
                </div>
              )}
              {isLoggedIn && (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to="/account/bookings"
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    My Bookings
                  </Link>
                </div>
              )}
              {false && isLoggedIn && (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to="/account/payments"
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    Payment Settings
                  </Link>
                </div>
              )}
              {isLoggedIn && (
                <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                  <Link
                    to="/account/settings"
                    className="tbk-whitespace-nowrap tbk-text-grey-main"
                  >
                    Account Settings
                  </Link>
                </div>
              )}
            </div>

            <div
              role={regionSelect ? "button" : undefined}
              className=""
              onClick={regionSelect ? openModal : null}
            >
              <div className="tbk-text-main tbk-mb-2 tbk-text-grey-main">
                <div className="tbk-whitespace-nowrap tbk-text-grey-main">
                  Region:{" "}
                  {user
                    ? user.region
                    : region /*process.env.REACT_APP_REGION*/ === "GB"
                    ? "UK"
                    : "US"}
                </div>
              </div>
            </div>

            <div className="lg:tbk-hidden">
              <a className="tb-logo-link tbk-text-grey-main" href="/?logo=1">
                <TruBeLogo
                  className="tbk-mb-2 tbk-hidden lg:tbk-block"
                  width={127}
                  height={38}
                />
                <TruBeLogo className="tbk-mb-2 lg:tbk-hidden" />
              </a>
              <div className="tbk-text-small tbk-text-grey-main">
                © 2025 TruBe.
                <br />
                All rights reserved.
                <br />
                <span
                  className={
                    process.env.NODE_ENV === "production" ? "tbk-hidden" : ""
                  }
                >
                  vers. {preval`module.exports = new Date().toLocaleString();`}.
                </span>
              </div>
            </div>
          </div>
          {/*<div className="tbk--order-1 tbk-col-span-2 tbk-hidden tbk-rounded-lg tbk-bg-basic-white tbk-p-3 tbk-shadow-trube lg:tbk-invisible lg:tbk-order-last lg:tbk-col-auto lg:tbk-block">*/}
          {/*  <div className="tbk-text-h3-subtitle tbk-mb-1 tbk-text-grey-main">*/}
          {/*    Want to know more?*/}
          {/*  </div>*/}
          {/*  <p className="tbk-text-secondary tbk-mb-2 tbk-text-grey">*/}
          {/*    Sign-up and be the first to hear about special offers, new*/}
          {/*    training options, and more.*/}
          {/*  </p>*/}
          {/*  <div className="tbk-text-small tbk-mb-0.5 tbk-text-grey-main">*/}
          {/*    Email address:*/}
          {/*  </div>*/}
          {/*  <input*/}
          {/*    ref={emailRef}*/}
          {/*    type="email"*/}
          {/*    className={`tbk-input-field tbk-mb-2 tbk-w-full tbk-text-blue-dark${*/}
          {/*      hasEmailError ? " tbk-border-coral" : ""*/}
          {/*    }`}*/}
          {/*    name="customerEmail"*/}
          {/*    placeholder="Enter your email"*/}
          {/*    value={email}*/}
          {/*    onChange={handleEmailChange}*/}
          {/*  />*/}
          {/*  <Button color="coral" className="tbk-mb-2 tbk-w-full">*/}
          {/*    Sign up*/}
          {/*  </Button>*/}
          {/*  <p className="tbk-text-small tbk-text-center tbk-text-grey">*/}
          {/*    By pressing "Sign up", you accept our{" "}*/}
          {/*    <a href="/terms/Terms of Use and Booking.pdf" target="_blank">*/}
          {/*      Terms of Use*/}
          {/*    </a>{" "}*/}
          {/*    and{" "}*/}
          {/*    <a href="/terms/TruBe - US Privacy Policy.pdf" target="_blank">*/}
          {/*      Privacy Policy*/}
          {/*    </a>*/}
          {/*  </p>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
};

Footer.displayName = "Footer";

export default Footer;
